import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ProjectService } from '../project/project.service';
import { UsersService } from '../users/users.service';

import { forkJoin, map, switchMap } from 'rxjs';
import { InvoicesService } from '../invoices/invoices.service';
import { ClientService } from '../clients/clients.service';

import { InvoiceGetDTO } from '../invoices/invoice.model';
import { ApiResponseModel } from '../../core/api-response.model';
import { RoleService } from '../../core/services/role.service';

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  protected http = inject(HttpClient);
  projectSvc = inject(ProjectService);
  usersSvc = inject(UsersService);
  rolesSvc = inject(RoleService);
  invoiceSvc = inject(InvoicesService);
  clientSvc = inject(ClientService);
  constructor() {}
  getDashboardData(invoiceQueryParams?: any) {
    const qp = {
      page: 1,
      limit: 10,
    };
    const getProject = this.projectSvc.get(undefined, {
      ...qp,
      status: 'Active',
    });
    const getClients = this.clientSvc.get(undefined, qp);
    const getUsers = this.usersSvc.get(undefined, qp);

    const getInvoices = this.invoiceSvc.get(undefined, invoiceQueryParams).pipe(
      map((res) => {
        return {
          ...res,
          data: res.data.map((item) => ({
            ...item,
            companyName: item.client.companyName,
            clientName: item.client.firstName + ' ' + item.client.lastName,
          })),
        } as ApiResponseModel<InvoiceGetDTO>;
      })
    );

    const getInvoicesPaid = this.invoiceSvc
      .get(undefined, {
        ...qp,
        markAsPaid: true,
      })
      .pipe(
        map((res) => {
          return {
            ...res,
            data: res.data.map((item) => ({
              ...item,
              companyName: item.client.companyName,
              clientName: item.client.firstName + ' ' + item.client.lastName,
            })),
          } as ApiResponseModel<InvoiceGetDTO>;
        })
      );

    return forkJoin({
      project: getProject,
      clients: getClients,
      users: getUsers,
      invoices: getInvoices,
      invoicePaid: getInvoicesPaid.pipe(map((res) => res.total)),
    });
  }
}
